const LOCALE = 'es-CO';
const relative = new Intl.RelativeTimeFormat('es', { numeric: 'auto', style: 'short' });
const dateTime = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
const time = new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit' });

const UNITS = [
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
];

function toDate(value) {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRelative(value, now = Date.now()) {
    const date = toDate(value);
    if (!date) return '—';
    const diff = date.getTime() - now;
    if (Math.abs(diff) < 45_000) return 'ahora';
    for (const [unit, ms] of UNITS) {
        if (Math.abs(diff) >= ms || unit === 'minute') {
            return relative.format(Math.round(diff / ms), unit);
        }
    }
    return '—';
}

export function formatDateTime(value) {
    const date = toDate(value);
    return date ? dateTime.format(date) : '—';
}

export function formatTime(value) {
    const date = toDate(value);
    return date ? time.format(date) : '—';
}

export function toIso(value) {
    return toDate(value)?.toISOString() ?? undefined;
}

export function partOfDay(now = new Date()) {
    const hour = now.getHours();
    if (hour < 12) return 'Buenos días';
    if (hour < 19) return 'Buenas tardes';
    return 'Buenas noches';
}
